import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiEnvelope } from '../../models/auth.dto';
import { WalletResponse, WalletTransactionResponse } from '../../models/wallet.dto';

@Injectable({ providedIn: 'root' })
export class WalletService {
  private apiUrl = environment.cbdx_service.api_path;

  constructor(private http: HttpClient) {}

  getWallet(): Observable<ApiEnvelope<WalletResponse>> {
    return this.http.get<ApiEnvelope<WalletResponse>>(`${this.apiUrl}/companies/me/wallet`);
  }

  listTransactions(page = 0, size = 20): Observable<ApiEnvelope<WalletTransactionResponse[]>> {
    const params = new HttpParams().set('page', page).set('size', size);
    return this.http.get<ApiEnvelope<WalletTransactionResponse[]>>(`${this.apiUrl}/companies/me/wallet/transactions`, {
      params,
    });
  }
}
